import React, { useState, useRef, useEffect } from "react";
import referalImage from '../assets/referalimage.png'; // Update path if needed
import LoaderScreen from "./LoaderScreen";
import getReferalResponse from '../services/services'; // Ensure this service is correctly implemented
import solidbackgroundimg from "../assets/solidbackgroundimg.png";
import { Translate } from "./LanguageChanger";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";

const ReferalCode = (masterHit, shouldFocus = false, referalDataCode, callback) => {
    console.log('masterHit', masterHit, referalDataCode);
     const [state, setState] = useState({
        shouldFocusGrid: shouldFocus,
        loading: true,
      });

      const { loading } = state;
    const referralCode = masterHit?.referalDataCode?.[0]?.refral_code || "";

    const selectedLang = localStorage.getItem("AppLanguage") || "English";

    useEffect(() => {
        setState((prevState) => ({
          ...prevState,
          loading: false,
        }));
        sendTestMatomoEvent({
            eventCategory: "Page",
            eventAction: "View",
            eventName: "ReferalCode",
            url: "referal-code",
        })
      }, []);

    return (
        <div style={styles.container}>
        {loading && <LoaderScreen />}
            {/* Left Image Section */}
            <div style={styles.imageSection}>
                <img src={referalImage} alt="Refer a Friend" style={styles.image} />
            </div>

            {/* Right Content Section */}
            <div style={{...styles.contentSection,marginBottom:"60px"}}>
            <h2 style={{fontSize:"38px" ,width:"800px",
                fontWeight:"300px"
            }}><Translate langKey={"inviteReferr"}/> </h2>
                {masterHit.masterHit.refral.text.map((item) => (
                    console.log('item', item),
                    <h2 style={styles.title}>
                        {item.language === selectedLang
                            ? item.content : ""}
                        {/* {item?.find(
                            (i) => i.language === selectedLang
                        ) || "Invite your friends to join the experience."} */}
                    </h2>
                ))}
                {/* <p style={styles.subtitle}>
          Because the best experiences are meant to be shared together
        </p> */}

                <label style={styles.label}><Translate langKey={"RefferalCode"}/></label>
                <input
                    type="text"
                    value={referralCode}
                    readOnly
                    style={styles.input}
                />
            </div>
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        // backgroundColor: '#050038',
          background: `url(${solidbackgroundimg})` ,
            //   height: '74vh',    
          backgroundSize: 'cover',
          backgroundPosition: 'center', // Center the background image
          backgroundRepeat: 'no-repeat',
        height: '100vh',
        padding: "20px",
        fontFamily: 'sans-serif',
        color: '#fff',
        
    },
    imageSection: {
        // flex: 1,
        display: 'flex',
        
    },
    image: {
        width: '550px',
        maxWidth: '550px',
    },
    contentSection: {
        // flex: 1,
        width:"700px",
        paddingLeft: '40px',
        paddingRight: '40px'
    },
    title: {
        fontSize: '22px',
        fontWeight: 'bold',
        marginBottom: '10px'
    },
    subtitle: {
        fontSize: '14px',
        color: '#ccc',
        marginBottom: '30px'
    },
    label: {
        marginTop:"40px",
        display: 'block',
        marginBottom: '8px',
        fontSize: '20px',
        color: '#fff'
    },
    input: {
        marginTop:"8px",
        width: '100%',
        padding: '12px 16px',
        fontSize: '16px',
        borderRadius: '6px',
        border: '1px solid #666',
        backgroundColor: '#050038',
        color: '#fff'
    }
};

export default ReferalCode;
